<script>
    export default {
        mounted() {
            this.mutableTags = this.tags;
            if (this.can_edit) {
                this.loadOptions();
            }
        },
        data() {
            return {
                newTag: '',
                mutableTags: [],
                options: [],
            }
        },
        props: {
            media_id: {
                type: Number
            },
            tags: {
                type: Array
            },
            can_edit: {
                type: Boolean
            },
        },
        methods: {
            addNewTag() {
                if (!this.newTag) {
                    toastr.warning('Please enter tag before saving', {timeOut: 3000});
                    return 0;
                }

                axios.post(Scoop.baseUrl + '/mediaserver/tags', {
                    'name': this.newTag,
                    'media_id': this.media_id
                }).then((response) => {
                    this.mutableTags = response.data;
                    this.newTag = '';
                    this.loadOptions();
                }).catch((error) => {
                    toastr.error(error, 'Could not save tag', {timeOut: 5000});
                    console.log(error);
                    this.newTag = '';
                });
            },
            deleteTag(id) {
                axios.delete(Scoop.baseUrl + '/mediaserver/tags/' + id).then((response) => {
                    if (response.data.success) {
                        this.mutableTags = response.data.tags;
                        this.loadOptions();
                    }
                });
            },
            addTag(label) {
                this.newTag = label;
                this.addNewTag();
            },
            loadOptions() {
                axios.get(`${Scoop.baseUrl}/api/searchMediaTags/`).then(res => {
                    this.options = this.filterOptions(res.data.items);
                });
            },
            filterOptions(options) {
                return _.filter(options, (option) => {
                    if (!this.mutableTags) {
                        return false;
                    }
                    return _.indexOf(this.mutableTags.map((tag) => {
                        return tag.name;
                    }), option.label) == -1;
                });
            },
            search: _.debounce((search, vm) => {
                axios.get(`${Scoop.baseUrl}/api/searchMediaTags/${escape(search)}`).then(res => {
                    vm.options = vm.filterOptions(res.data.items);
                });
            }, 200)
        },
        watch: {
            newTag(value) {
                this.search(value, this);
            }
        },
        computed: {
            limitedOptions() {
                return _.slice(this.options, 0, 10);
            },
        },
    }
</script>

<template>
    <div>
        <div v-if="!can_edit" class="alert alert-warning m-b-md">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            You are not allowed to edit tags
        </div>

        <div class="addNewTag m-b-lg" v-if="can_edit">
            <h5>Add new tag:</h5>
            <div class="input-group">
                <input type="text" class="form-control" v-model="newTag" @keyup.enter="addNewTag">
                <span class="input-group-btn">
                    <button type="button" class="btn btn-primary" @click="addNewTag">
                        <i class="fa fa-plus-square" aria-hidden="true"></i>
                    </button>
                </span>
            </div>
            <span class="label m-r-xs m-b-xs inline" v-for="option in limitedOptions">
                <span>{{ option.label }}</span>
                <span class="btn btn-sm" @click="addTag(option.label)" style="padding: 0 0 0 10px; margin: 0">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </span>
            </span>
        </div>
        <div v-if="mutableTags && mutableTags.length > 0" class="activeTags">
            <h5>Existing tags:</h5>
            <span class="label m-r-xs m-b-xs inline" v-for="tag in mutableTags">
                <span>{{ tag.name }}</span>
                <span class="btn btn-sm" @click="deleteTag(tag.id)" v-if="can_edit"
                      style="padding: 0 0 0 10px; margin: 0">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </span>
            </span>
        </div>
        <div v-else class="alert alert-info">
            No tags yet
        </div>
    </div>
</template>